/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validPhone(str) {
  return (/^[1][3456789]\d{9}$/).test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validIdentityCard(str) {
  return (/(^\d{18}$)|(^\d{17}(\d|X)$)/).test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validEmail(str) {
  return (/^.+@.+\..+$/).test(str)
}

